import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Ancient_Civilizations_-_Ancient_Egypt.png';

export default function HistoryPageEgyptGo() {
  return (
    <QuizPage
      title="History: Ancient Egypt"
      subTopic="Ancient Egypt"
      backgroundImage={historyImage}
      returnPath="/History-Ancient-Egypt"
    />
  );
}
